// components/EmailSummaryPopup.tsx
import React, { useState } from 'react';
import { GenericPopup } from './GenericPopup';
import './EmailSummaryPopup.scss';

export interface DepartmentMember {
  _id: string;
  name: string;
}

interface EmailSummaryPopupProps {
  isOpen: boolean;
  onClose: () => void;
  defaultEmail: string;
  onSend: (recipientId: string | null, patientName: string) => void;
  departmentMembers?: DepartmentMember[];
}

export const EmailSummaryPopup: React.FC<EmailSummaryPopupProps> = ({
  isOpen,
  onClose,
  defaultEmail,
  onSend,
  departmentMembers = [],
}) => {
  const [mode, setMode] = useState<'CONFIRM' | 'EDIT'>('CONFIRM');
  const [selectedEmail, setSelectedEmail] = useState('');
  const [patientName, setPatientName] = useState('');

  const handleReset = () => {
    setMode('CONFIRM');
    setSelectedEmail('');
    setPatientName('');
    onClose();
  };

  const nameInput = (
    <input
      type="text"
      className="email-input"
      data-clarity-mask="true"
      placeholder="שם המטופל (אופציונלי)"
      value={patientName}
      onChange={(e) => setPatientName(e.target.value)}
      style={{ marginTop: '8px' }}
    />
  );

  // CONFIRM mode
  if (mode === 'CONFIRM') {
    return (
      <GenericPopup
        isOpen={isOpen}
        title="לאן לשלוח את הסיכום?"
        onClose={handleReset}
        primaryButtonText="למייל זה"
        onPrimaryClick={() => onSend(null, patientName)}
        secondaryButtonText="שנה"
        onSecondaryClick={() => setMode('EDIT')}
      >
        <div className="asthma-wrapper">
          <div className="email-confirm-content">
            <p className="email-label">המייל השמור במערכת הוא:</p>
            <p className="email-address">{defaultEmail}</p>
          </div>
          <div className="email-edit-content">
            {nameInput}
          </div>
        </div>
      </GenericPopup>
    );
  }

  // EDIT mode — dropdown or message
  const isValidSelection = selectedEmail !== '';

  return (
    <GenericPopup
      isOpen={isOpen}
      title="לאן לשלוח את הסיכום?"
      onClose={handleReset}
      primaryButtonText="שליחה"
      primaryButtonDisabled={!isValidSelection}
      onPrimaryClick={() => onSend(selectedEmail || null, patientName)}
      secondaryButtonText="סגירה"
      onSecondaryClick={handleReset}
    >
      <div className="asthma-wrapper">
        <div className="email-edit-content">
          {departmentMembers.length > 0 ? (
            <select
              className="email-select"
              value={selectedEmail}
              onChange={(e) => setSelectedEmail(e.target.value)}
            >
              <option value="">בחר נמען...</option>
              {departmentMembers.map((member) => (
                <option key={member._id} value={member._id}>
                  {member.name}
                </option>
              ))}
            </select>
          ) : (
            <p className="input-helper-text">לא נמצאו חברי מחלקה לשליחה</p>
          )}
          {nameInput}
        </div>
      </div>
    </GenericPopup>
  );
};